import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, message } from "antd";
import { BrowserQRCodeReader } from "@zxing/browser";
import {
  query,
  where,
  collection,
  getDocs,
  doc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebaseConfig"; // Asegúrate de importar correctamente tu instancia de Firebase

const QRScannerModal = ({ visible, setIsQRReaderModalVisible }) => {
  const [ticketData, setTicketData] = useState(null);

  const videoRef = useRef(null);
  const streamRef = useRef(null);

  useEffect(() => {
    if (visible) {
      const codeReader = new BrowserQRCodeReader();

      codeReader.decodeFromVideoDevice(
        null,
        videoRef.current,
        (result, err) => {
          if (result) {
            handleScan(result.getText());
            stopStream(); // Detener el stream después de un escaneo exitoso
          }
          if (err && err.name !== "NotFoundException") {
            console.error("Error:", err);
          }
        }
      );

      // Guardar el stream de video
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then((stream) => {
          videoRef.current.srcObject = stream;
          streamRef.current = stream;
        })
        .catch((err) => console.error("Error al acceder a la cámara:", err));
    } else {
      stopStream(); // Detener el stream cuando se cierra el modal
    }

    return () => {
      stopStream(); // Detener el stream al desmontar el componente
    };
  }, [visible]);

  const handleScan = async (data) => {
    try {
      const ticketJson = JSON.parse(data);

      if (ticketJson.id) {
        console.log("Escaneando QR:", ticketJson);

        const ticketQuery = query(
          collection(db, "tickets"),
          where("id", "==", ticketJson.id) // Buscar por la propiedad id
        );

        const querySnapshot = await getDocs(ticketQuery);

        if (!querySnapshot.empty) {
          const ticketDoc = querySnapshot.docs[0]; // Obtener el primer resultado
          console.log(ticketDoc.data());
          setTicketData(ticketDoc.data()); // Mostrar la información del ticket
        } else {
          message.error("Ticket no encontrado");
        }
      }
      // Aquí buscarías el ticket en tu base de datos
    } catch (error) {
      message.error("Hubo un problema al procesar el QR");
    }
  };

  const stopStream = () => {
    if (streamRef.current) {
      const tracks = streamRef.current.getTracks();
      tracks.forEach((track) => track.stop()); // Detener cada track del stream
      streamRef.current = null; // Limpiar la referencia
    }
  };

  const handleConfirmTicket = async () => {
    if (ticketData) {
      try {
        const ticketQuery = query(
          collection(db, "tickets"),
          where("id", "==", ticketData.id) // Buscar por la propiedad id
        );

        const querySnapshot = await getDocs(ticketQuery);

        if (!querySnapshot.empty) {
          const ticketDoc = querySnapshot.docs[0];
          const ticketRef = doc(db, "tickets", ticketDoc.id); // Referencia al documento

          console.log(ticketDoc.data());

          await updateDoc(ticketRef, { consumido: true });
          message.success("Ticket confirmado con éxito");
          setIsQRReaderModalVisible(false);
          setTicketData(null);
        }
      } catch (error) {
        console.error("Error al confirmar el ticket:", error);
        message.error("Hubo un error al confirmar el ticket");
      }
    }
  };

  return (
    <>
      <Modal
        title="Escanear QR"
        visible={visible}
        onCancel={() => {
          setIsQRReaderModalVisible(false);
          setTicketData(null);
        }}
        footer={null}
      >
        {!ticketData ? (
          <video ref={videoRef} style={{ width: "100%" }} />
        ) : ticketData ? (
          <div>
            <h3>Información del Ticket</h3>
            <p>
              <strong>ID:</strong> {ticketData.id}
            </p>
            <p>
              <strong>Nombre:</strong> {ticketData.informacionPersonal}
            </p>
            <p>
              <strong>Visita:</strong> {ticketData.visita}
            </p>
            <p>
              <strong>Fecha:</strong> {ticketData.fechaYHora}
            </p>
            <p>
              <strong>Confirmado:</strong> {ticketData.consumido ? "Sí" : "No"}
            </p>
            <Button type="primary" size="large" onClick={handleConfirmTicket}>
              Confirmar Ticket
            </Button>
          </div>
        ) : (
          <p>Coloca el QR frente a la cámara</p>
        )}
      </Modal>
    </>
  );
};

export default QRScannerModal;
